import React from 'react';
import { Row, Col, Card } from 'antd';
import MarketerBalanceFilter from './MarketerBalanceFilter';
import MarketerBalanceTable from './MarketerBalanceTable';

export default function MarketerBalanceReport() {
    
    return (
        <Card className="report-table">
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <MarketerBalanceFilter />
                    <MarketerBalanceTable />    
                </Col>
            </Row>
            </Card>
    )
}
